import React from "react";
import { createSearchParams, useNavigate } from "react-router-dom";
import Collaboration from "image/collaboration.png";
import { getTranslation } from "common";
import { Stack, TextField, Button, Box, Grid, Typography } from "@mui/material";
import { useTranslations, useForm } from "hooks";
import { isEmail, isRequired, Validation } from "hooks/useForm";
import { noTokenApi } from "api";
import { Link } from "react-router-dom";

export default function Email() {
  const translations = useTranslations();
  const navigate = useNavigate();

  const validations: Validation[] = [
    ({ email }) =>
      isRequired(email) || {
        email: getTranslation(translations, "register.valid.Error_after_at"),
      },
    ({ email }) =>
      isEmail(email) || {
        email: getTranslation(translations, "register.valid.Error_after_at"),
      },
  ];
  const { values, errors, touched, changeHandler, isValid } = useForm(
    { email: "" },
    validations
  );

  const submitEmail = async (e: React.FormEvent<HTMLButtonElement>) => {
    e.preventDefault();
    const response = await noTokenApi.get(
      `users/emailinplatform/${values.email}`
    );
    if (response.status === 200) {
      // dispatch(addEmail(values.email));
      //navigate(response.data.mailexist ? "/login" : "/registration", { state: { email: values.email } });
      navigate({
        pathname: response.data.mailexist ? "/login" : "/registration",
        search: createSearchParams({ email: values.email }).toString(),
      });
    }
  };

  return (
    <React.Fragment>
      <Grid container spacing={2} height="100vh" width="100vw">
        <Grid
          item
          container
          display="flex"
          justifyContent="center"
          alignItems="center"
          sm={12}
          md={6}
        >
          <Stack
            justifyContent="center"
            spacing={2}
            px={2}
            flex={1}
            alignItems="center"
          >
            <Typography textTransform="capitalize" variant="h3">
              {getTranslation(translations, "register.label.description1")}
            </Typography>
            <Typography variant="body1">
              {getTranslation(translations, "register.label.description2")}
            </Typography>
            <Stack
              component="form"
              direction="row"
              alignItems="center"
              spacing={2}
            >
              <TextField
              id="welcome-email"
                label={getTranslation(translations, "user.email.label")}
                value={values.email}
                onChange={({ target }) => changeHandler("email", target.value)}
                error={Boolean(touched.email && errors.email)}
                helperText={touched.email && errors.email}
                type="email"
                aria-controls="email"
                size="small"
                fullWidth
              />
              <Button
              id="welcome-button"
                variant="contained"
                size="small"
                type="submit"
                disabled={!isValid}
                onClick={submitEmail}
              >
                {getTranslation(
                  translations,
                  "register.label.button_register_is_free"
                )}
              </Button>
            </Stack>
            <Button component={Link} to="/login" variant="text" color="inherit">
              {getTranslation(
                translations,
                "register.label.ahref_login_have_account"
              )}
            </Button>
          </Stack>
        </Grid>

        <Grid
          item
          sm={12}
          md={6}
          px={2}
          alignItems="center"
          justifyContent="center"
          display="flex"
        >
          <Box
            component="img"
            width="100%"
            src={Collaboration}
            alt="Collaboration"
            sx={{ margin: "auto" }}
          />
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
